module.exports = __webpack_public_path__ + "static/media/align-left.40dbfee7.svg";